// extracted by mini-css-extract-plugin
export var auto = "_4j-1";
export var spinner = "_4j-0";